import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcErrorH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.321 61c-5.434 0-8.796-5.924-6.01-10.59L29.99 14.112c2.716-4.548 9.303-4.548 12.02 0L63.686 50.41c2.787 4.666-.575 10.59-6.01 10.59zm-4.292-9.564c-1.99 3.332.41 7.563 4.292 7.563h43.357c3.881 0 6.283-4.23 4.292-7.563L40.292 15.137c-1.94-3.248-6.645-3.248-8.585 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36 51q-.62 0-1.06-.441a1.45 1.45 0 0 1-.44-1.06q0-.618.44-1.059T36 48t1.059.44.44 1.06q0 .618-.44 1.059t-1.06.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 26a1 1 0 0 1 1 1v17a1 1 0 0 1-2 0V27a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  }));
}
var IcErrorH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcErrorH72));

export { IcErrorH72 as I };
